// Wipe every cached form value, keeping only what the session needs to stay signed in.
//
// Each page caches its own form under its own localStorage key and several pages decide their
// read-only lock from that cache. So a cache left behind by the previously opened request makes
// the next request look validated: the section renders pre-filled and locked, and an MLNO
// unlock is needed to recover. Where the section has no record yet on the server, its fetch
// 404s and cannot correct the stale lock.
//
// Removing named keys is what let this happen — the removal lists were written when there were
// four form keys and were never extended as pages were added, so riskFormData,
// riskFormDataContinued, managers, managersStatus, EDDFormData and loadedDocs kept surviving.
// Clearing everything except the auth keys cannot fall behind that way: a form key added
// tomorrow is covered without touching this file.
//
// Cached reference data (countries, currency, exchanges) is cleared too and simply re-fetched.
const PRESERVED_KEYS = ["token", "refreshToken", "userName", "userEmail"];

export const resetFormCache = () => {
  const preserved = PRESERVED_KEYS.map((key) => [key, localStorage.getItem(key)]);

  localStorage.clear();

  preserved.forEach(([key, value]) => {
    if (value !== null) localStorage.setItem(key, value);
  });
};
